import React from 'react'
import BlogPostsListView from '../../views/School/BlogPostsListView'
import SchoolMaterialThemeContainer from '../../containers/SchoolMaterialThemeContainer'
import { ISchool } from '../../interfaces/school.interface'
import { getSchoolBlogPostsRequest } from '../../services/api-requests/school-blog-request'
import { ISchoolBlog } from '../../components/Blogs/useBlogs'
import SchoolUserParentContainerComponent from '../../containers/SchoolUser/SchoolUserParentContainerComponent'
import SchoolUserPageHead from '../../components/SchoolUserPageHead'
import { useSchoolDetails } from '../../hooks/useSchoolDetails'
import ErrorComponent from '../_error'
import PageLoadingComponent from '../../components/LoadingComponents/PageLoadingComponent'

const BlogListPage = (props: {
  schoolDetails: ISchool
  posts: ISchoolBlog[]
}) => {
  return (
    <>
      {props.schoolDetails && (
        <SchoolUserPageHead schoolDetails={props.schoolDetails} />
      )}
      <SchoolMaterialThemeContainer schoolDetails={props.schoolDetails}>
        <>
          <SchoolUserParentContainerComponent
            school_id={props.schoolDetails?._id}
            fb_pixel_id={props.schoolDetails?.fb_pixels_id}
          >
            <BlogPostsListView
              posts={props.posts}
              schoolDetails={props.schoolDetails}
            />
          </SchoolUserParentContainerComponent>
        </>
      </SchoolMaterialThemeContainer>
    </>
  )
}

const BlogListWrapper: React.FC<any> = () => {
  const { error: schoolError, schoolDetails } = useSchoolDetails()
  const [posts, setPosts] = React.useState<ISchoolBlog[]>([])
  const [postsLoading, setPostsLoading] = React.useState(false)

  React.useEffect(() => {
    if (!schoolDetails?._id) {
      return
    }

    let active = true
    const fetchPosts = async () => {
      setPostsLoading(true)
      try {
        const postsRes = await getSchoolBlogPostsRequest({
          schoolId: schoolDetails._id,
          includeArchived: false,
          hideDetails: true,
          includeUnpublished: false,
        }).catch(() => null)
        if (!active) return
        setPosts(postsRes?.data?.data || [])
      } catch (err) {
        if (active) {
          console.error('Error fetching blog posts', err)
        }
      } finally {
        if (active) {
          setPostsLoading(false)
        }
      }
    }

    fetchPosts().catch(err => {
      console.error('Error fetching blog posts', err)
      if (active) {
        setPostsLoading(false)
      }
    })

    return () => {
      active = false
    }
  }, [schoolDetails?._id])

  if (schoolError) {
    return <ErrorComponent statusCode={404} />
  }

  if (!schoolDetails || postsLoading) {
    return <PageLoadingComponent />
  }
  return <BlogListPage schoolDetails={schoolDetails} posts={posts} />
}

export default BlogListWrapper
